module.exports = __webpack_public_path__ + "static/media/join-support-program-update-v3.e6eaf3b9.png";